import { IS_MAC } from '../../ui/keys';
import { tip } from '../../ui/tooltip';
import { setHeldKey, useHeldKeys } from '../touchInput';

/**
 * Shift and Option for a finger (Artwork A, 2026-10-26: "Shift and Option become small toggles"):
 * pressed, a chip stays down until it is pressed again, and every press on the canvas meanwhile is
 * made with that key held — Shift adds to the selection and keeps proportions, Option drags a copy.
 * Drawn on touch screens only, beside the zoom pill.
 */
export function HeldKeys() {
  const held = useHeldKeys();
  return (
    <div role="group" aria-label="Keys held for the canvas" className="held-keys">
      <button type="button" className="held-key" aria-pressed={held.shift} {...tip('Shift: add to the selection, keep proportions')} onClick={() => setHeldKey('shift', !held.shift)}>
        ⇧ Shift
      </button>
      <button type="button" className="held-key" aria-pressed={held.alt} {...tip(`${IS_MAC ? 'Option' : 'Alt'}: drag a copy`)} onClick={() => setHeldKey('alt', !held.alt)}>
        {IS_MAC ? '⌥ Option' : 'Alt'}
      </button>
    </div>
  );
}
